export const API_ENDPOINTS = {
  LOOKUP: {
        GET_COUNTRY: "Country/Search",
        GET_CITY: "City/Search",
        GET_CITY_BY_ID: "City/SearchByCityId",
        UPDATE_CITY: "City/Update",
        GET_CURRENCY: "Currency/Search",
        EXPORT_COUNTRY: "Country/Export",
        EXPORT_CITY: "City/Export",
        EXPORT_CURRENCY: "Currency/Export",
        UPDATE_COUNTRY: "Country/Update",
        GET_COUNTRY_BY_ID: "Country/GetCountryById",
    // Add other  endpoints here
  },
 
};

export const QUERY_KEYS = {
    LOOKUP: {
        COUNTRY: ["CountrySearch"], // UNIQUE IN OVER ALL APPLICATION
        CITY: ["CitySearch"],
        CURRENCY: ["CurrencySearch"]
  },
  
};